import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const GoogleAds: React.FC<IconProps> = ({ color, size, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" style={{ ...style }} viewBox="0 0 32 32" data-testid="googleads-icon">
    <path
      fill={color ?? '#fff'}
      d="M5.333 29.574a5.333 5.333 0 1 1 0-10.667 5.333 5.333 0 0 1 0 10.667Zm25.952-8.002L20.62 3.096a5.335 5.335 0 0 0-9.24 5.334l10.668 18.476a5.335 5.335 0 0 0 9.238-5.334ZM10.02 5.46 2.085 19.198a6 6 0 0 1 3.248-.958c3.414-.01 6.167 2.878 5.992 6.287l4.29-7.43L10.8 8.762a5.947 5.947 0 0 1-.782-3.304Z"
    />
  </svg>
);
export default GoogleAds;
